import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-portfolio',
  templateUrl: './app-portfolio.component.html',
  styleUrls: ['./app-portfolio.component.scss']
})
export class AppPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
